import LoaderWrapper from '@/components/ui/LoaderWrapper/LoaderWrapper.tsx';
import NotLoggedIn from '@/router/middleware/NotLoggedIn.tsx';
import AuthAdmin from '@/router/middleware/AuthAdmin.tsx';
import IsLoggedIn from '@/router/middleware/IsLoggedIn.tsx';
import AuthManager from '@/router/middleware/AuthManager.tsx';

const middlewareConfig = {
  middlewaresMap: {
    authAdmin: <AuthAdmin />,
    authManager: <AuthManager />,
    notLoggedIn: <NotLoggedIn />,
    loggedIn: <IsLoggedIn />,
  },
  loader: <LoaderWrapper isLoading className="h-screen" />,
} as const;

export type MiddlewareType = keyof (typeof middlewareConfig)['middlewaresMap'];

export default middlewareConfig;
